import { createContext, useContext } from 'react';

const QueryPersistReadyContext = createContext(false);

export const QueryPersistReadyProvider = QueryPersistReadyContext.Provider;

export const useQueryPersistReady = () => useContext(QueryPersistReadyContext);
